// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* —— Package — Add package price drawer (Stitch) —— */
.pkg-price-drawer.ant-drawer .ant-drawer-content-wrapper {
  width: 440px !important;
  max-width: calc(100vw - 16px);
}

.pkg-price-drawer .ant-drawer-header {
  display: none;
}

.pkg-price-drawer .ant-drawer-body {
  padding: 0 !important;
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background: #ffffff;
}

.pkg-price-drawer .ant-drawer-mask {
  background: rgba(15, 23, 42, 0.2);
  backdrop-filter: blur(1px);
}

.pkg-price-drawer__shell {
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 0;
}

.pkg-price-drawer__header {
  flex-shrink: 0;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  padding: 24px;
  border-bottom: 1px solid #E2E8F0;
  background: #ffffff;
}

.pkg-price-drawer__title-block {
  min-width: 0;
}

.pkg-price-drawer__title-row {
  display: flex;
  align-items: center;
  gap: 8px;
}

.pkg-price-drawer__dot {
  width: 8px;
  height: 8px;
  border-radius: 9999px;
  background: #0EA5E9;
  flex-shrink: 0;
}

.pkg-price-drawer__title {
  margin: 0;
  font-size: 16px;
  font-weight: 700;
  letter-spacing: -0.02em;
  color: #0F172A;
  line-height: 1.3;
}

.pkg-price-drawer__subtitle {
  margin: 4px 0 0;
  font-size: 12px;
  line-height: 1.45;
  color: #64748B;
}

.pkg-price-drawer__close {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border: 0;
  border-radius: 8px;
  background: transparent;
  color: #94A3B8;
  cursor: pointer;
  flex-shrink: 0;
}

.pkg-price-drawer__close:hover {
  background: #F1F5F9;
  color: #0F172A;
}

.pkg-price-drawer__body {
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 20px;
  background: #ffffff;
}

.pkg-price-drawer__field {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.pkg-price-drawer__label {
  font-size: 12px;
  font-weight: 600;
  color: #0F172A;
  line-height: 1.3;
}

.pkg-price-drawer__req {
  color: #F43F5E;
}

.pkg-price-drawer__hint {
  font-size: 11px;
  line-height: 1.4;
  color: #64748B;
}

.pkg-price-drawer__error {
  font-size: 11px;
  color: #E11D48;
}

.pkg-price-drawer__control {
  width: 100%;
}

.pkg-price-drawer__text-input.ant-input,
.pkg-price-drawer__textarea.ant-input {
  width: 100%;
  min-height: 36px;
  border-radius: 8px;
  border-color: #E2E8F0;
  font-size: 13px;
  color: #0F172A;
  box-shadow: none;
}

.pkg-price-drawer__text-input.ant-input {
  height: 36px;
  padding: 0 12px;
}

.pkg-price-drawer__textarea.ant-input {
  min-height: 96px;
  padding: 8px 12px;
  line-height: 1.45;
  resize: vertical;
}

.pkg-price-drawer__text-input.ant-input:focus,
.pkg-price-drawer__textarea.ant-input:focus {
  border-color: #0EA5E9;
  box-shadow: 0 0 0 1px #0EA5E9;
}

.pkg-price-drawer__text-input.ant-input-disabled,
.pkg-price-drawer__field.is-dimmed .pkg-price-drawer__text-input.ant-input-disabled {
  background: #F8FAFC !important;
  color: #64748B !important;
}

.pkg-price-drawer__control.ant-input-number,
.pkg-price-drawer__control.ant-picker,
.pkg-price-drawer__control.ant-select .ant-select-selector {
  width: 100% !important;
  min-height: 36px !important;
  border-radius: 8px !important;
  border-color: #E2E8F0 !important;
  box-shadow: none !important;
}

.pkg-price-drawer__control.ant-input-number {
  padding-inline: 4px;
}

.pkg-price-drawer__control.ant-input-number .ant-input-number-input {
  height: 34px;
  font-size: 13px;
  color: #0F172A;
  font-variant-numeric: tabular-nums;
}

.pkg-price-drawer__control.ant-picker {
  padding-inline: 12px;
}

.pkg-price-drawer__control.ant-picker .ant-picker-input > input {
  font-size: 13px;
  color: #0F172A;
}

.pkg-price-drawer__control.ant-select .ant-select-selector {
  padding-inline: 11px !important;
  align-items: center;
}

.pkg-price-drawer__control.ant-select-focused .ant-select-selector,
.pkg-price-drawer__control.ant-input-number-focused,
.pkg-price-drawer__control.ant-picker-focused {
  border-color: #0EA5E9 !important;
  box-shadow: 0 0 0 1px #0EA5E9 !important;
}

.pkg-price-drawer__amount-wrap {
  position: relative;
  display: flex;
  align-items: center;
}

.pkg-price-drawer__amount-wrap .ant-input-number {
  width: 100%;
  min-height: 36px;
  border-radius: 8px;
  border-color: #E2E8F0;
  padding-inline-end: 48px;
}

.pkg-price-drawer__amount-wrap .ant-input-number-focused {
  border-color: #0EA5E9;
  box-shadow: 0 0 0 1px #0EA5E9;
}

.pkg-price-drawer__amount-wrap .ant-input-number-input {
  height: 34px;
  font-size: 13px;
  font-weight: 500;
  font-variant-numeric: tabular-nums;
  color: #0F172A;
}

.pkg-price-drawer__currency {
  position: absolute;
  inset-inline-end: 12px;
  font-size: 12px;
  font-weight: 600;
  color: #64748B;
  pointer-events: none;
}

.pkg-price-drawer__notice {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 12px;
  border-radius: 8px;
  border: 1px solid #E0F2FE;
  background: rgba(240, 249, 255, 0.5);
  color: #0C4A6E;
}

.pkg-price-drawer__notice .lucide {
  color: #0EA5E9;
  flex-shrink: 0;
  margin-top: 1px;
}

.pkg-price-drawer__notice p {
  margin: 0;
  font-size: 11.5px;
  line-height: 1.5;
}

.pkg-price-drawer__footer {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 12px;
  padding: 16px 24px;
  border-top: 1px solid #E2E8F0;
  background: #F8FAFC;
}

.pkg-price-drawer__btn {
  box-sizing: border-box;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  height: 36px;
  padding: 0 16px;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 500;
  font-family: inherit;
  cursor: pointer;
  transition: background 0.12s ease, border-color 0.12s ease, color 0.12s ease;
}

.pkg-price-drawer__btn:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

.pkg-price-drawer__btn--ghost {
  border: 1px solid #E2E8F0;
  background: transparent;
  color: #64748B;
}

.pkg-price-drawer__btn--ghost:hover:not(:disabled) {
  background: #ffffff;
  color: #0F172A;
}

.pkg-price-drawer__btn--primary {
  border: 1px solid #0EA5E9;
  background: #0EA5E9;
  color: #ffffff;
  box-shadow: 0 1px 2px rgba(14, 165, 233, 0.2);
}

.pkg-price-drawer__btn--primary:hover:not(:disabled) {
  background: #0284C7;
  border-color: #0284C7;
}

/* Edit mode: dimmed read-only fields */
.pkg-price-drawer__field.is-dimmed {
  opacity: 0.55;
  pointer-events: none;
}

.pkg-price-drawer__field.is-dimmed .pkg-price-drawer__label {
  color: #64748B;
}

.pkg-price-drawer__field.is-dimmed .ant-input-number-disabled,
.pkg-price-drawer__field.is-dimmed .ant-select-disabled .ant-select-selector,
.pkg-price-drawer__field.is-dimmed .ant-picker-disabled {
  background: #F8FAFC !important;
  color: #64748B !important;
  cursor: not-allowed;
}

.pkg-price-drawer__field.is-dimmed .ant-input-number-disabled .ant-input-number-input,
.pkg-price-drawer__field.is-dimmed .ant-picker-disabled input {
  color: #64748B !important;
}

.pkg-price-drawer__field--toggle {
  padding: 12px;
  border: 1px solid #E2E8F0;
  border-radius: 8px;
  background: #ffffff;
}

.pkg-price-drawer__toggle-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
}

.pkg-price-drawer__toggle-row .pkg-price-drawer__hint {
  margin: 2px 0 0;
}

.pkg-price-drawer__toggle-row .ant-switch-checked {
  background: #0EA5E9;
}
`, "",{"version":3,"sources":["webpack://./src/pages/ShowPackage/components/drawers/AddPackagePriceDrawer.css"],"names":[],"mappings":"AAAA,sDAAsD;AACtD;EACE,uBAAuB;EACvB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,iCAAiC;EACjC,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,cAAc;EACd,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,aAAa;EACb,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,UAAU;EACV,WAAW;EACX,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,SAAS;EACT,kBAAkB;EAClB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,gBAAgB;EAChB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;;EAEE,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;EACrB,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;;EAEE,qBAAqB;EACrB,6BAA6B;AAC/B;;AAEA;;EAEE,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;;;EAGE,sBAAsB;EACtB,2BAA2B;EAC3B,6BAA6B;EAC7B,gCAAgC;EAChC,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,cAAc;EACd,kCAAkC;AACpC;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,+BAA+B;EAC/B,mBAAmB;AACrB;;AAEA;;;EAGE,gCAAgC;EAChC,wCAAwC;AAC1C;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;EACrB,wBAAwB;AAC1B;;AAEA;EACE,qBAAqB;EACrB,6BAA6B;AAC/B;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,aAAa;EACb,kBAAkB;EAClB,yBAAyB;EACzB,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,SAAS;EACT,kBAAkB;EAClB,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,4EAA4E;AAC9E;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,6CAA6C;AAC/C;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA,uCAAuC;AACvC;EACE,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,cAAc;AAChB;;AAEA;;;EAGE,8BAA8B;EAC9B,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB","sourcesContent":["/* —— Package — Add package price drawer (Stitch) —— */\n.pkg-price-drawer.ant-drawer .ant-drawer-content-wrapper {\n  width: 440px !important;\n  max-width: calc(100vw - 16px);\n}\n\n.pkg-price-drawer .ant-drawer-header {\n  display: none;\n}\n\n.pkg-price-drawer .ant-drawer-body {\n  padding: 0 !important;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  background: #ffffff;\n}\n\n.pkg-price-drawer .ant-drawer-mask {\n  background: rgba(15, 23, 42, 0.2);\n  backdrop-filter: blur(1px);\n}\n\n.pkg-price-drawer__shell {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  min-height: 0;\n}\n\n.pkg-price-drawer__header {\n  flex-shrink: 0;\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 24px;\n  border-bottom: 1px solid #E2E8F0;\n  background: #ffffff;\n}\n\n.pkg-price-drawer__title-block {\n  min-width: 0;\n}\n\n.pkg-price-drawer__title-row {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.pkg-price-drawer__dot {\n  width: 8px;\n  height: 8px;\n  border-radius: 9999px;\n  background: #0EA5E9;\n  flex-shrink: 0;\n}\n\n.pkg-price-drawer__title {\n  margin: 0;\n  font-size: 16px;\n  font-weight: 700;\n  letter-spacing: -0.02em;\n  color: #0F172A;\n  line-height: 1.3;\n}\n\n.pkg-price-drawer__subtitle {\n  margin: 4px 0 0;\n  font-size: 12px;\n  line-height: 1.45;\n  color: #64748B;\n}\n\n.pkg-price-drawer__close {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  height: 32px;\n  border: 0;\n  border-radius: 8px;\n  background: transparent;\n  color: #94A3B8;\n  cursor: pointer;\n  flex-shrink: 0;\n}\n\n.pkg-price-drawer__close:hover {\n  background: #F1F5F9;\n  color: #0F172A;\n}\n\n.pkg-price-drawer__body {\n  flex: 1 1 auto;\n  min-height: 0;\n  overflow-y: auto;\n  padding: 24px;\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  background: #ffffff;\n}\n\n.pkg-price-drawer__field {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.pkg-price-drawer__label {\n  font-size: 12px;\n  font-weight: 600;\n  color: #0F172A;\n  line-height: 1.3;\n}\n\n.pkg-price-drawer__req {\n  color: #F43F5E;\n}\n\n.pkg-price-drawer__hint {\n  font-size: 11px;\n  line-height: 1.4;\n  color: #64748B;\n}\n\n.pkg-price-drawer__error {\n  font-size: 11px;\n  color: #E11D48;\n}\n\n.pkg-price-drawer__control {\n  width: 100%;\n}\n\n.pkg-price-drawer__text-input.ant-input,\n.pkg-price-drawer__textarea.ant-input {\n  width: 100%;\n  min-height: 36px;\n  border-radius: 8px;\n  border-color: #E2E8F0;\n  font-size: 13px;\n  color: #0F172A;\n  box-shadow: none;\n}\n\n.pkg-price-drawer__text-input.ant-input {\n  height: 36px;\n  padding: 0 12px;\n}\n\n.pkg-price-drawer__textarea.ant-input {\n  min-height: 96px;\n  padding: 8px 12px;\n  line-height: 1.45;\n  resize: vertical;\n}\n\n.pkg-price-drawer__text-input.ant-input:focus,\n.pkg-price-drawer__textarea.ant-input:focus {\n  border-color: #0EA5E9;\n  box-shadow: 0 0 0 1px #0EA5E9;\n}\n\n.pkg-price-drawer__text-input.ant-input-disabled,\n.pkg-price-drawer__field.is-dimmed .pkg-price-drawer__text-input.ant-input-disabled {\n  background: #F8FAFC !important;\n  color: #64748B !important;\n}\n\n.pkg-price-drawer__control.ant-input-number,\n.pkg-price-drawer__control.ant-picker,\n.pkg-price-drawer__control.ant-select .ant-select-selector {\n  width: 100% !important;\n  min-height: 36px !important;\n  border-radius: 8px !important;\n  border-color: #E2E8F0 !important;\n  box-shadow: none !important;\n}\n\n.pkg-price-drawer__control.ant-input-number {\n  padding-inline: 4px;\n}\n\n.pkg-price-drawer__control.ant-input-number .ant-input-number-input {\n  height: 34px;\n  font-size: 13px;\n  color: #0F172A;\n  font-variant-numeric: tabular-nums;\n}\n\n.pkg-price-drawer__control.ant-picker {\n  padding-inline: 12px;\n}\n\n.pkg-price-drawer__control.ant-picker .ant-picker-input > input {\n  font-size: 13px;\n  color: #0F172A;\n}\n\n.pkg-price-drawer__control.ant-select .ant-select-selector {\n  padding-inline: 11px !important;\n  align-items: center;\n}\n\n.pkg-price-drawer__control.ant-select-focused .ant-select-selector,\n.pkg-price-drawer__control.ant-input-number-focused,\n.pkg-price-drawer__control.ant-picker-focused {\n  border-color: #0EA5E9 !important;\n  box-shadow: 0 0 0 1px #0EA5E9 !important;\n}\n\n.pkg-price-drawer__amount-wrap {\n  position: relative;\n  display: flex;\n  align-items: center;\n}\n\n.pkg-price-drawer__amount-wrap .ant-input-number {\n  width: 100%;\n  min-height: 36px;\n  border-radius: 8px;\n  border-color: #E2E8F0;\n  padding-inline-end: 48px;\n}\n\n.pkg-price-drawer__amount-wrap .ant-input-number-focused {\n  border-color: #0EA5E9;\n  box-shadow: 0 0 0 1px #0EA5E9;\n}\n\n.pkg-price-drawer__amount-wrap .ant-input-number-input {\n  height: 34px;\n  font-size: 13px;\n  font-weight: 500;\n  font-variant-numeric: tabular-nums;\n  color: #0F172A;\n}\n\n.pkg-price-drawer__currency {\n  position: absolute;\n  inset-inline-end: 12px;\n  font-size: 12px;\n  font-weight: 600;\n  color: #64748B;\n  pointer-events: none;\n}\n\n.pkg-price-drawer__notice {\n  display: flex;\n  align-items: flex-start;\n  gap: 10px;\n  padding: 12px;\n  border-radius: 8px;\n  border: 1px solid #E0F2FE;\n  background: rgba(240, 249, 255, 0.5);\n  color: #0C4A6E;\n}\n\n.pkg-price-drawer__notice .lucide {\n  color: #0EA5E9;\n  flex-shrink: 0;\n  margin-top: 1px;\n}\n\n.pkg-price-drawer__notice p {\n  margin: 0;\n  font-size: 11.5px;\n  line-height: 1.5;\n}\n\n.pkg-price-drawer__footer {\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 12px;\n  padding: 16px 24px;\n  border-top: 1px solid #E2E8F0;\n  background: #F8FAFC;\n}\n\n.pkg-price-drawer__btn {\n  box-sizing: border-box;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  height: 36px;\n  padding: 0 16px;\n  border-radius: 8px;\n  font-size: 13px;\n  font-weight: 500;\n  font-family: inherit;\n  cursor: pointer;\n  transition: background 0.12s ease, border-color 0.12s ease, color 0.12s ease;\n}\n\n.pkg-price-drawer__btn:disabled {\n  opacity: 0.55;\n  cursor: not-allowed;\n}\n\n.pkg-price-drawer__btn--ghost {\n  border: 1px solid #E2E8F0;\n  background: transparent;\n  color: #64748B;\n}\n\n.pkg-price-drawer__btn--ghost:hover:not(:disabled) {\n  background: #ffffff;\n  color: #0F172A;\n}\n\n.pkg-price-drawer__btn--primary {\n  border: 1px solid #0EA5E9;\n  background: #0EA5E9;\n  color: #ffffff;\n  box-shadow: 0 1px 2px rgba(14, 165, 233, 0.2);\n}\n\n.pkg-price-drawer__btn--primary:hover:not(:disabled) {\n  background: #0284C7;\n  border-color: #0284C7;\n}\n\n/* Edit mode: dimmed read-only fields */\n.pkg-price-drawer__field.is-dimmed {\n  opacity: 0.55;\n  pointer-events: none;\n}\n\n.pkg-price-drawer__field.is-dimmed .pkg-price-drawer__label {\n  color: #64748B;\n}\n\n.pkg-price-drawer__field.is-dimmed .ant-input-number-disabled,\n.pkg-price-drawer__field.is-dimmed .ant-select-disabled .ant-select-selector,\n.pkg-price-drawer__field.is-dimmed .ant-picker-disabled {\n  background: #F8FAFC !important;\n  color: #64748B !important;\n  cursor: not-allowed;\n}\n\n.pkg-price-drawer__field.is-dimmed .ant-input-number-disabled .ant-input-number-input,\n.pkg-price-drawer__field.is-dimmed .ant-picker-disabled input {\n  color: #64748B !important;\n}\n\n.pkg-price-drawer__field--toggle {\n  padding: 12px;\n  border: 1px solid #E2E8F0;\n  border-radius: 8px;\n  background: #ffffff;\n}\n\n.pkg-price-drawer__toggle-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n}\n\n.pkg-price-drawer__toggle-row .pkg-price-drawer__hint {\n  margin: 2px 0 0;\n}\n\n.pkg-price-drawer__toggle-row .ant-switch-checked {\n  background: #0EA5E9;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
